import { render } from "./AdminReservations.vue?vue&type=template&id=482a28a0"
import script from "./AdminReservations.vue?vue&type=script&lang=js"
export * from "./AdminReservations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__